import React,{useEffect,useState,useRef} from 'react'
import { useDispatch, useSelector} from "react-redux";
import { useParams ,Link} from "react-router-dom";
import moment from 'moment';
import { Drawer,Form,Button,Row, Col,Divider,Typography ,DatePicker,Select,Input } from 'antd';
import { DownloadOutlined,PlusCircleFilled,EditFilled ,DeleteFilled} from '@ant-design/icons';

import useAxios from './../../CustomHooks/useAxios';
import ShowItspsTable from './ShowItspsTable';
import PageLink from './../PageLink/PageLink';

import AddItsps from "./AddItsps";
const { Text } = Typography;
const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';

export default function Itsps() {
    let { page } = useParams();
    const {axiosi}=useAxios();

    const [visibleAdd, setVisibleAdd] = useState(false);
    const [data,setData]=useState();
    const [refreshSearch,setRefreshSearch]=useState(true);

    const handleAdd=()=>{
        console.log("[handleAdd]:");
        setVisibleAdd(true);
    }
    const onCloseAdd=()=>{
        setVisibleAdd(false);
        
    }

    useEffect(()=>{
        doSearch();
    },[refreshSearch,page]);

    const [name,setName]=useState('');
    const handleSearch= (val)=>{
        console.log("[handleSearch]");
        setName(val);
        setRefreshSearch(pre=>!pre)
    }

    const doSearch= async()=>{
        console.log("[search]");
        const kq=await axiosi.get('itsps',{params:{name,page,pageSize:20}});
        console.log("[handleSearch]:kq.data=",kq.data);
        setData(kq.data);
    }
  return (<>
  
        <Drawer title="Add  Menu Item" placement="right" onClose={onCloseAdd} visible={visibleAdd}>             
                    <AddItsps setVisibleAdd={setVisibleAdd} setRefreshSearch={setRefreshSearch} />        
            </Drawer>
        <section className='search'>
        <div className="container">
            <div className="row">
                <Typography.Title  level={3}>Search :
                <Button onClick={handleAdd}  className="addButton" icon={<PlusCircleFilled  style={{ color: '#1890ff' }} />}>Add</Button>
                </Typography.Title>
                
            </div>
            
            <div className="row">
            <Input.Group compact>      
                <Input.Search addonBefore="ITSP Name: " enterButton 
                 onSearch={handleSearch} allowClear 
                 style={{ width: '70%' }} defaultValue="" />
            </Input.Group>
                {/* <div className="col">
                    <label>menu item name :</label>
                    <Input  onChange={({ target: { value } } )=>setName(value)}/>
                </div>
                <div className="col">
                    <label>Search:</label>
                    <Button onClick={handleSearch}>Search :</Button>
                </div> */}
                
            </div>
        </div>

    </section>
    <section className='searchResult'>
        <div className="row">
        <Typography.Title  level={3}>Result</Typography.Title>
        </div>
        <div className="row">
            {data?.rows && <ShowItspsTable data={data.rows} setRefreshSearch={setRefreshSearch} />}
        </div>
    
        <div className="row">
        {data?.pages>1?<PageLink pageSize={data.pageSize} searchpage={"itsps"} pages={data.pages} numrows={data.numrows} page={data.page} />:<h1>chi co' 1 page</h1>}
        </div>

    </section>
  </>);
}
